import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { SiteNav } from "@/components/store/SiteNav";
import { KineticHero } from "@/components/store/KineticHero";
import { EditorialMarquee } from "@/components/store/EditorialMarquee";
import { SystemBento } from "@/components/store/SystemBento";
import { InsidePreview } from "@/components/store/InsidePreview";
import { WeeklyLoop } from "@/components/store/WeeklyLoop";
import { BuyPanel } from "@/components/store/BuyPanel";
import { Faq } from "@/components/store/Faq";
import { Footer } from "@/components/store/Footer";

export default function Storefront() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, anchors: { offset: -80 } });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);

  return (
    <div className="grain min-h-screen overflow-x-clip" data-testid="storefront">
      <SiteNav />
      <KineticHero />
      <EditorialMarquee />
      <SystemBento />
      <InsidePreview />
      <WeeklyLoop />
      <BuyPanel />
      <Faq />
      <Footer />
    </div>
  );
}
